import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import ProductConfig, {ProductSupport} from "@/model/ProductConfig";

@Singleton
export default abstract class ProductConfigApi {
    abstract edit(form: PconfigEditForm): Promise<ProductConfig>
}

class ProductConfigApiImpl extends BaseApi implements ProductConfigApi {

    protected urlPrefix = 'product/config'

    edit(form: PconfigEditForm): Promise<ProductConfig> {
        return this.axios.post('edit', form)
    }
}

Container.bind(ProductConfigApi).to(ProductConfigApiImpl)

export class PconfigEditForm {
    productId!: number
    support!: ProductSupport
}